import { backofficeRequest } from '../../../../axios'

export const fetchInterlocutors = async (ticketId) => {
  try {
    const response = await backofficeRequest.get(
      `backoffice/tickets/${ticketId}/interlocutors`
    )
    return response
  } catch (error) {
    return error.response
  }
}
